import {List, ListItem, ListItemAvatar, ListItemText, Stack, Typography} from "@mui/material";
import EmployeeAvatar from "../employee-avatar/EmployeeAvatar";
import EmployeeLink from "../employee-link/EmployeeLink";
import {grey} from "@mui/material/colors";
import {VisitWithAssignedDesksStats} from "../visit-stat-block/OfficeVisitStats";
import {AssignedDesks} from "../../api/AssignedDeskStore";


export default function EmployeeList({stats, assignedDesks}: {
    stats: VisitWithAssignedDesksStats,
    assignedDesks: AssignedDesks,
}) {
    return (
        <List>
            {stats.employeeStats.employees.map(({employee, visits}) => {
                const employeeDesks = assignedDesks.desksOf(employee)
                const shouldHaveDesk = stats.employeeStats.assignedDeskRecommendationEmployees.has(employee.id);
                return (
                    <ListItem key={employee.id}>
                        <ListItemAvatar>
                            <EmployeeAvatar employee={employee}/>
                        </ListItemAvatar>
                        <ListItemText>
                            <EmployeeLink employee={employee} color="white"/>
                            <Stack direction="row" justifyContent="space-between" spacing={3}>
                                {employeeDesks && (
                                    <Typography
                                        variant="body2"
                                        sx={employeeDesks.length > 0 ? {
                                            color: 'white',
                                            backgroundColor: theme => theme.palette.primary.main,
                                            px: 1,
                                            borderRadius: 2
                                        } : {
                                            color: grey.A400,
                                        }}
                                    >
                                        {employeeDesks.length === 0 ? 'no desk' : employeeDesks.map(desk => desk.name).join(', ')}
                                    </Typography>
                                )}
                                <Typography variant="body2">
                                    {visits ? visits.value : '?'} ({visits ? visits.percent : '?'}%)
                                </Typography>
                            </Stack>
                            <Typography variant="body2" sx={{color: shouldHaveDesk ? 'white' : grey.A400}}>
                                {stats.assignedDeskCriteria.deskComment(shouldHaveDesk)}
                            </Typography>
                        </ListItemText>
                    </ListItem>
                );
            })}
        </List>
    );
}